import ScannerWidget from "../components/ScannerWidget";
import CtaLink, { btnPrimary, btnOutline } from "../components/CtaLink";
import { usePricing, bookingHref } from "../lib/catalog";
import site from "../content/site.json";

function Booking() {
  const { data } = usePricing();
  const s = data?.booking?.score_review_url, c = data?.booking?.strategy_call_url;
  if (!s && !c) return <p className="text-sm text-slate-500 mb-5" data-testid="contact-booking-pending">[Booking links coming soon — add CALENDLY_SCORE_REVIEW_URL and CALENDLY_STRATEGY_CALL_URL.]</p>;
  return (
    <div className="flex flex-wrap gap-3 mb-8">
      {s && <CtaLink to={bookingHref(s)} className={btnPrimary} testid="contact-score-review">Book a 15-min Score Review</CtaLink>}
      {c && <CtaLink to={bookingHref(c)} className={btnOutline} testid="contact-strategy-call">Book a Strategy Call</CtaLink>}
    </div>
  );
}

export default function ContentPage({ slug }) {
  const c = site.pages[slug] || site.pages.blog;
  return (
    <div>
      <section className="bg-slate-950 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <p className="font-mono text-xs uppercase tracking-widest text-indigo-300 mb-3">Make My Business AI Ready <span className="text-indigo-400/60">(AgenticReady)</span></p>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight">{c.title}</h1>
          {c.lead && <p className="mt-4 text-xl text-slate-300">{c.lead}</p>}
        </div>
      </section>
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        {c.body.map((p, i) => <p key={i} className="text-slate-600 leading-relaxed mb-5">{p}</p>)}
        {(c.sections || []).map((s) => (
          <div key={s.h} className="mb-6" data-testid={`section-${s.h.toLowerCase().replace(/\W+/g, "-")}`}>
            <h2 className="font-heading text-lg font-bold text-slate-900">{s.h}</h2>
            <p className="text-slate-600 leading-relaxed mt-1">{s.p}</p>
          </div>
        ))}
        {slug === "contact" && <Booking />}
        <div className="mt-8 rounded-2xl border border-slate-200 bg-white p-7">
          <h3 className="font-heading text-xl font-bold text-slate-900">See where your business stands</h3>
          <p className="text-slate-500 mt-1 mb-5">Run a free AI Revenue Readiness scan.</p>
          <ScannerWidget variant="light" />
        </div>
      </section>
    </div>
  );
}
